import { FunctionComponent } from 'react'
import { Route } from 'next'
import EventCardView from '@/app/_components/EventCard/EventCardView'
import { useSeller, useSitePath } from '@/app/_providers/SellerProvider/SellerProvider'

type Props = {
  event: Transformed.EventForCard
}

/**
 * An event card for the themed events routes, linking into the current venue's site.
 *
 * Reads the site path and the city from the seller, so it must render inside a `SellerProvider`.
 * Outside one — a server component, say — render `EventCardView` directly and pass `href` and `cityName` yourself.
 *
 * @param {Props} props - The card props.
 * @returns {ReactNode} The rendered event card.
 */
const EventCard: FunctionComponent<Props> = ({ event }: Props) => {
  const sitePath = useSitePath()
  const { cityName } = useSeller()

  return (
    <EventCardView
      event={event}
      href={`/${sitePath}/${event.url}` as Route}
      cityName={cityName}
    />
  )
}

export default EventCard
